// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../shared/font/gteestiprodisplay_regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../shared/font/gteestiprodisplay_bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../shared/font/gteestiprodisplay_light.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "GteDisplayBold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-style: normal;
  font-weight: normal;
}
@font-face {
  font-family: "GteDisplayExtra";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-style: normal;
  font-weight: normal;
}
@font-face {
  font-family: "GteDisplayLight";
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
  font-weight: normal;
}
.authorization_form__AwrSE {
  margin-top: 60px;
  margin-bottom: auto;
  display: flex;
  width: 100%;
  align-items: stretch;
}

.authorization_passBody__DhmME {
  position: relative;
  z-index: 0;
}
.authorization_passBody__DhmME button {
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  right: 25px;
  font-size: 0;
  margin: 0;
  padding: 0;
}

.authorization_inputPassword__1C94R {
  border: none;
  outline: none;
  background: #FAFAFA;
  width: 100%;
  padding: 15px 20px 14px 20px;
  border-radius: 30px;
  font-family: GteDisplayBold;
  font-weight: 500;
  font-size: 16px;
}
.authorization_inputPassword__1C94R::placeholder {
  color: #C2C2C2;
}

.authorization_wrapper__lMjob {
  display: flex;
  flex-direction: column;
  grid-gap: 10px;
  margin: 10px;
}

.authorization_resetPassword__1nAwl {
  text-decoration: none;
  font-size: 15px;
  font-family: GteDisplayLight;
  color: #000000;
}

.authorization_inputBody__TjB70 {
  display: block;
  width: 100%;
}
.authorization_inputBody__TjB70 input {
  background: #FAFAFA;
  width: 100%;
  padding: 17px 20px 12px 17px;
  border-radius: 0 30px 30px 0;
  outline: none;
  border: none;
  font-family: GteDisplayBold;
  font-weight: 500;
  font-size: 16px;
}
.authorization_inputBody__TjB70 input::placeholder {
  color: #C2C2C2;
}`, "",{"version":3,"sources":["webpack://./src/pages/authorization/authorization.module.scss"],"names":[],"mappings":"AAAA;EACE,6BAAA;EACA,+DAAA;EACA,kBAAA;EACA,mBAAA;AACF;AACA;EACE,8BAAA;EACA,+DAAA;EACA,kBAAA;EACA,mBAAA;AACF;AACA;EACE,8BAAA;EACA,kBAAA;EACA,+DAAA;EACA,mBAAA;AACF;AAEA;EACE,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,oBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,UAAA;AAAF;AAEE;EACE,kBAAA;EACA,QAAA;EACA,6BAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;AAAJ;;AAIA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,4BAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;EACA,eAAA;AADF;AAEE;EACE,cAAA;AAAJ;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;AAFF;;AAKA;EACE,qBAAA;EACA,eAAA;EACA,4BAAA;EACA,cAAA;AAFF;;AAKA;EACE,cAAA;EACA,WAAA;AAFF;AAGE;EACE,mBAAA;EACA,WAAA;EACA,4BAAA;EACA,4BAAA;EACA,aAAA;EACA,YAAA;EACA,2BAAA;EACA,gBAAA;EACA,eAAA;AADJ;AAEI;EACE,cAAA;AAAN","sourcesContent":["@font-face {\r\n  font-family: \"GteDisplayBold\";\r\n  src: url('../../shared/font/gteestiprodisplay_regular.otf') format(\"truetype\");\r\n  font-style: normal;\r\n  font-weight: normal;\r\n}\r\n@font-face {\r\n  font-family: \"GteDisplayExtra\";\r\n  src: url('../../shared/font/gteestiprodisplay_bold.otf') format(\"truetype\");\r\n  font-style: normal;\r\n  font-weight: normal;\r\n}\r\n@font-face {\r\n  font-family: \"GteDisplayLight\";\r\n  font-style: normal;\r\n  src: url('../../shared/font/gteestiprodisplay_light.otf') format(\"truetype\");\r\n  font-weight: normal;\r\n}\r\n\r\n.form {\r\n  margin-top: 60px;\r\n  margin-bottom: auto;\r\n  display: flex;\r\n  width: 100%;\r\n  align-items: stretch;\r\n}\r\n\r\n.passBody {\r\n  position: relative;\r\n  z-index: 0;\r\n\r\n  button {\r\n    position: absolute;\r\n    top: 50%;\r\n    transform: translate(0, -50%);\r\n    right: 25px;\r\n    font-size: 0;\r\n    margin: 0;\r\n    padding: 0;\r\n  }\r\n}\r\n\r\n.inputPassword {\r\n  border: none;\r\n  outline: none;\r\n  background: #FAFAFA;\r\n  width: 100%;\r\n  padding: 15px 20px 14px 20px;\r\n  border-radius: 30px;\r\n  font-family: GteDisplayBold;\r\n  font-weight: 500;\r\n  font-size: 16px;\r\n  &::placeholder {\r\n    color: #C2C2C2;\r\n\r\n  }\r\n}\r\n\r\n.wrapper {\r\n  display: flex;\r\n  flex-direction: column;\r\n  grid-gap: 10px;\r\n  margin: 10px;\r\n}\r\n\r\n.resetPassword {\r\n  text-decoration: none;\r\n  font-size: 15px;\r\n  font-family: GteDisplayLight;\r\n  color: #000000;\r\n}\r\n\r\n.inputBody {\r\n  display: block;\r\n  width: 100%;\r\n  input {\r\n    background: #FAFAFA;\r\n    width: 100%;\r\n    padding: 17px 20px 12px 17px;\r\n    border-radius: 0 30px 30px 0;\r\n    outline: none;\r\n    border: none;\r\n    font-family: GteDisplayBold;\r\n    font-weight: 500;\r\n    font-size: 16px;\r\n    &::placeholder {\r\n      color: #C2C2C2;\r\n\r\n    }\r\n  }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `authorization_form__AwrSE`,
	"passBody": `authorization_passBody__DhmME`,
	"inputPassword": `authorization_inputPassword__1C94R`,
	"wrapper": `authorization_wrapper__lMjob`,
	"resetPassword": `authorization_resetPassword__1nAwl`,
	"inputBody": `authorization_inputBody__TjB70`
};
export default ___CSS_LOADER_EXPORT___;
